import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z","key":"svg-0"}],["path",{"d":"M10 10l2 -2l2 2","key":"svg-1"}],["path",{"d":"M10 14l2 2l2 -2","key":"svg-2"}]]

const IconElevator = createReactComponent('outline', 'elevator', 'Elevator', __iconNode);

export default IconElevator;